import { createTheme } from "@mui/material/styles";

// Material Dashboard 2 React base styles
import colors from "../../asset/theme/base/colors";
import breakpoints from "../../asset/theme/base/breakpoints";
import typography from "../../asset/theme/base/typography";
import boxShadows from "../../asset/theme/base/boxShadows";
import borders from "../../asset/theme/base/borders";
import globals from "../../asset/theme/base/globals";

// Material Dashboard 2 React helper functions
import boxShadow from "../../asset/theme/functions/boxShadow";
import hexToRgb from "../../asset/theme/functions/hexToRgb";
import linearGradient from "../../asset/theme/functions/linearGradient";
import pxToRem from "../../asset/theme/functions/pxToRem";
import rgba from "../../asset/theme/functions/rgba";

// Material Dashboard 2 React components base styles for @mui material components
import sidenav from "../../asset/theme/components/sidenav";
import list from "../../asset/theme/components/list";
import listItem from "../../asset/theme/components/list/listItem";
import listItemText from "../../asset/theme/components/list/listItemText";
import card from "../../asset/theme/components/card";
import cardMedia from "../../asset/theme/components/card/cardMedia";
import cardContent from "../../asset/theme/components/card/cardContent";
import button from "../../asset/theme/components/button";
import iconButton from "../../asset/theme/components/iconButton";
import input from "../../asset/theme/components/form/input";
import inputLabel from "../../asset/theme/components/form/inputLabel";
import inputOutlined from "../../asset/theme/components/form/inputOutlined";
import textField from "../../asset/theme/components/form/textField";
import menu from "../../asset/theme/components/menu";
import menuItem from "../../asset/theme/components/menu/menuItem";
import switchButton from "../../asset/theme/components/form/switchButton";
import divider from "../../asset/theme/components/divider";
import tableContainer from "../../asset/theme/components/table/tableContainer";
import tableHead from "../../asset/theme/components/table/tableHead";
import tableCell from "../../asset/theme/components/table/tableCell";
import linearProgress from "../../asset/theme/components/linearProgress";
import breadcrumbs from "../../asset/theme/components/breadcrumbs";
import slider from "../../asset/theme/components/slider";
import avatar from "../../asset/theme/components/avatar";
import tooltip from "../../asset/theme/components/tooltip";
import appBar from "../../asset/theme/components/appBar";
import tabs from "../../asset/theme/components/tabs";
import tab from "../../asset/theme/components/tabs/tab";
import stepper from "../../asset/theme/components/stepper";
import step from "../../asset/theme/components/stepper/step";
import stepConnector from "../../asset/theme/components/stepper/stepConnector";
import stepLabel from "../../asset/theme/components/stepper/stepLabel";
import stepIcon from "../../asset/theme/components/stepper/stepIcon";
import select from "../../asset/theme/components/form/select";
import formControlLabel from "../../asset/theme/components/form/formControlLabel";
import formLabel from "../../asset/theme/components/form/formLabel";
import checkbox from "../../asset/theme/components/form/checkbox";
import radio from "../../asset/theme/components/form/radio";
import autocomplete from "../../asset/theme/components/form/autocomplete";
import container from "../../asset/theme/components/container";
import popover from "../../asset/theme/components/popover";
import buttonBase from "../../asset/theme/components/buttonBase";
import icon from "../../asset/theme/components/icon";
import svgIcon from "../../asset/theme/components/svgIcon";
import link from "../../asset/theme/components/link";
import dialog from "../../asset/theme/components/dialog";
import dialogTitle from "../../asset/theme/components/dialog/dialogTitle";
import dialogContent from "../../asset/theme/components/dialog/dialogContent";
import dialogContentText from "../../asset/theme/components/dialog/dialogContentText";
import dialogActions from "../../asset/theme/components/dialog/dialogActions";

export default createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  boxShadows: { ...boxShadows },
  borders: { ...borders },
  functions: {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...container,
      },
    },
    MuiDrawer: { ...sidenav },
    MuiList: { ...list },
    MuiListItem: { ...listItem },
    MuiListItemText: { ...listItemText },
    MuiCard: { ...card },
    MuiCardMedia: { ...cardMedia },
    MuiCardContent: { ...cardContent },
    MuiButton: { ...button },
    MuiIconButton: { ...iconButton },
    MuiInput: { ...input },
    MuiInputLabel: { ...inputLabel },
    MuiOutlinedInput: { ...inputOutlined },
    MuiTextField: { ...textField },
    MuiMenu: { ...menu },
    MuiMenuItem: { ...menuItem },
    MuiSwitch: { ...switchButton },
    MuiDivider: { ...divider },
    MuiTableContainer: { ...tableContainer },
    MuiTableHead: { ...tableHead },
    MuiTableCell: { ...tableCell },
    MuiLinearProgress: { ...linearProgress },
    MuiBreadcrumbs: { ...breadcrumbs },
    MuiSlider: { ...slider },
    MuiAvatar: { ...avatar },
    MuiTooltip: { ...tooltip },
    MuiAppBar: { ...appBar },
    MuiTabs: { ...tabs },
    MuiTab: { ...tab },
    MuiStepper: { ...stepper },
    MuiStep: { ...step },
    MuiStepConnector: { ...stepConnector },
    MuiStepLabel: { ...stepLabel },
    MuiStepIcon: { ...stepIcon },
    MuiSelect: { ...select },
    MuiFormControlLabel: { ...formControlLabel },
    MuiFormLabel: { ...formLabel },
    MuiCheckbox: { ...checkbox },
    MuiRadio: { ...radio },
    MuiAutocomplete: { ...autocomplete },
    MuiPopover: { ...popover },
    MuiButtonBase: { ...buttonBase },
    MuiIcon: { ...icon },
    MuiSvgIcon: { ...svgIcon },
    MuiLink: { ...link },
    MuiDialog: { ...dialog },
    MuiDialogTitle: { ...dialogTitle },
    MuiDialogContent: { ...dialogContent },
    MuiDialogContentText: { ...dialogContentText },
    MuiDialogActions: { ...dialogActions },
  },
});
